import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

/**
 * Tab de Responsaveis do Dojo.
 * Duas tabelas: Professores Responsaveis + Responsavel Tecnico.
 *
 * Props:
 *  - gym
 *  - onAddResponsible / onDeleteResponsible
 *  - onAddTechnical / onDeleteTechnical
 */
export function TabGymResponsibles({
    gym,
    onAddResponsible,
    onDeleteResponsible,
    onAddTechnical,
    onDeleteTechnical,
}) {
    const { t } = useTranslation();

    const responsibleAction = (rowData) => (
        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger"
            onClick={() => onDeleteResponsible(rowData)} />
    );

    const technicalAction = (rowData) => (
        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger"
            onClick={() => onDeleteTechnical(rowData)} />
    );

    return (
        <>
            <p></p>
            <label htmlFor="name">{gym.name}</label>
            <p></p>

            <DataTable value={gym.gymResponsibles} responsiveLayout="scroll">
                <Column field="name" header={t('msg.jkaName')} sortable style={{ minWidth: '2rem' }} />
                <Column field="grade.level" header={t('msg.jkaGrade')} sortable style={{ minWidth: '2rem' }} />
                <Column body={responsibleAction} exportable={false} style={{ minWidth: '1rem' }} />
            </DataTable>
            <br />
            <Button icon="pi pi-plus-circle" iconPos="right" onClick={onAddResponsible} />

            <br /><br />
            <label htmlFor="tech resp">Responsável técnico</label>
            <br /><br />

            <DataTable value={gym.technicalResponsibles} responsiveLayout="scroll">
                <Column field="name" header={t('msg.jkaName')} sortable style={{ minWidth: '2rem' }} />
                <Column field="grade.level" header={t('msg.jkaGrade')} sortable style={{ minWidth: '2rem' }} />
                <Column body={technicalAction} exportable={false} style={{ minWidth: '1rem' }} />
            </DataTable>
            <br />
            <Button icon="pi pi-plus-circle" iconPos="right" onClick={onAddTechnical} />
        </>
    );
}
